<div>
    <ng-container *ngIf="!ngControl.disabled">
        <mat-label class="font-weight-400">{{label}}</mat-label>
        <mat-radio-group
                aria-labelledby="example-radio-group-label"
                class="example-radio-group"
                [formControl]="ngControl.control">
            <mat-radio-button class="example-radio-button" *ngFor="let item of items" [value]="item.id">
                <div style="display: flex; flex-direction: row">
                    <div [style.background]="item.color" class="color-indicator"></div>
                    <span>{{item.description}}</span>
                </div>
            </mat-radio-button>
        </mat-radio-group>
<!--        <mat-form-field appearance="outline" floatLabel="always" color="accent" style="width: 100%;">-->
<!--            <mat-select class="multiple-selection" [formControl]="ngControl.control" [placeholder]="placeholder" multiple>-->
<!--                &lt;!&ndash; CLOSED CONTROL &ndash;&gt;-->
<!--                <mat-select-trigger>                            -->
<!--                    <div class="multiple-selection-item">-->
<!--                        <mat-chip-list>-->
<!--                            <mat-chip *ngFor="let selectedItemId of ngControl.value" class="chip-item" color="accent" selected>-->
<!--                                {{ getItemDescription(selectedItemId) | translate }}-->
<!--                            </mat-chip>-->
<!--                        </mat-chip-list>-->
<!--                    </div>-->
<!--                </mat-select-trigger>-->
<!--                <mat-option *ngFor="let item of _items$ | async"-->
<!--                    [value]="item.id">-->
<!--                    {{item.description | translate}}-->
<!--                </mat-option>-->
<!--            </mat-select>             -->
<!--        </mat-form-field> -->
        <!-- errors -->
        <ng-container *ngIf="ngControl.touched">
            <mat-error *ngIf="ngControl.hasError('required')">{{'INPUT.REQUIRED' | translate}}</mat-error>
        </ng-container> 
    </ng-container>

    <ng-container *ngIf="ngControl.disabled">
        <mat-label class="font-weight-400">{{label}}</mat-label>
        <div style="font-weight: bold; display: flex; flex-direction: row">
            <div [style.background]="items|getById:value:'color'" class="color-indicator"></div>
            <span>{{items|getById:value:'description'}}</span>
        </div>
    </ng-container>
</div>
